import DadosClienteCrudBordero from './DadosClienteCrudBordero';

export default DadosClienteCrudBordero;
